import api from "../../client";
export interface DeleteFileResponse {}

export const deleteLogo = async (
  institutionId: string,
): Promise<DeleteFileResponse> => {
  const { data } = await api.delete<DeleteFileResponse>(
    `/institution/${institutionId}/delete-logo`,
  );
  return data;
};
